import React, { useState } from 'react';

import Accordions from '../accordions';

import { IAccordionTabs } from './accordionTabList.definition';

export const AccordionTabList = (props: IAccordionTabs) => {
	const { overskrift, accordionTabList } = props;
	const hasAccordions = accordionTabList && accordionTabList.length > 0;

	if (!hasAccordions) {
		return null;
	}

	const [currentTab, setCurrentTab] = useState(accordionTabList[0]);
	const { boxes } = currentTab || {};

	return (
		<section className="AccordionTablist">
			<div>
				{ overskrift && (
					<h4 className="mb-2 AccordionTablist__Headline">
						{ overskrift }
					</h4>
				) }

				{ accordionTabList && accordionTabList.length > 0 && (
					<ul className="AccordionTablist__List">
						{ accordionTabList.map((accordionsListItem, idx) => {
							const { tab } = accordionsListItem;
							const active = currentTab.tab === accordionsListItem.tab;

							return (
								<li key={ idx } className="AccordionTablist__ListItem">
									<button
										className={ ['square-button', active ? 'button-type-3' : 'button-type-1'].join(' ') }
										onClick={ () => setCurrentTab(accordionsListItem) }
									>
										{ tab }
									</button>
								</li>
							);
						}) }
					</ul>
				) }
			</div>

			<div>
				{ boxes && boxes.length > 0 && (
					<Accordions boxes={ boxes } />
				) }
			</div>
		</section>
	);
};

export default AccordionTabList;
